// src/components/common/Sidebar.tsx
import { SidebarLogo, SidebarMenu } from "@/components/common";
import { Button } from "@/components/ui";
import { cn } from "@/lib/utils";

type SidebarProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
};

export default function Sidebar({ open, setOpen }: SidebarProps) {
    return (
        <aside
            className={cn(
                "bg-background fixed inset-y-0 left-0 z-20 flex h-full w-64 flex-col transition-transform duration-300 md:static border-r",
                !open && "-translate-x-full md:translate-x-0 md:w-20"
            )}
        >
            <SidebarLogo isCollapsed={!open} />
            <SidebarMenu isCollapsed={!open} />

            {/* Collapsed indicator */}
            {!open && (
                <div className="px-4 py-2">
                    <Button
                        variant="ghost"
                        size="sm"
                        className="w-full text-muted-foreground hover:text-foreground"
                        onClick={() => setOpen(true)}
                    >
                        •••
                    </Button>
                </div>
            )}
        </aside>
    );
}